if (!customElements.get('rm-sideload-cart')) {
  customElements.define('rm-sideload-cart', class RmProductSlider extends HTMLElement {
    constructor() {
      super();

      this.isOpen = false;
      this.scrollPosition = 0;

      this.cart = {};
      this.cartData = {};

      this.rmDeliveryUpsell = document.querySelector('rm-delivery-upsell');
      this.rmProductUpsell = document.getElementById('rm-sideload-cart-upsell');

      this.mainContent = document.getElementById("rm-main-content");
      this.mainContentInner = document.getElementById("rm-main-content-inner");
      this.sideLoadCart = document.getElementById("rm-sideload-cart");
      this.closeBtn = document.getElementById('rm-sideload-cart-close-btn');
      this.spinner = document.getElementById('rm-sideload-cart-spinner');
      this.cartContent = document.getElementById('rm-sideload-cart-content');
      this.cartContentBottom = document.getElementById('rm-sideload-cart-content-bottom');
      this.productsContainer = document.getElementById('rm-sideload-cart-products');
      this.continueBtn = document.getElementById('rm-sideload-cart-continue-shopping');
      this.checkoutBtn = document.getElementById('rm-sideload-cart-checkout-btn');
      this.setupCheckoutUrl();
      this.setupEventListeners()
      // Listen for Rebuy cart changes globally and sync our UI
      document.addEventListener('rebuy:cart.change', this.handleRebuyCartChange.bind(this));
      // Listen for Rebuy popup close actions to open our cart
      document.addEventListener('click', this.handleRebuyPopupCloseClick.bind(this), true);
      // Observe Rebuy popup visibility; when it appears, open cart behind the scenes
      this.setupRebuyPopupObserver();
    }

    getLocaleFromGlobalVars() {
      // Try to get locale from the shopifyLocalization global object first
      if (window.shopifyLocalization && window.shopifyLocalization.locale) {
        return window.shopifyLocalization.locale;
      }
      
      // Try to build locale from separate language and country if available
      if (window.shopifyLocalization && window.shopifyLocalization.language && window.shopifyLocalization.country) {
        return `${window.shopifyLocalization.language}-${window.shopifyLocalization.country}`;
      }
      
      // Check current URL path for locale prefix (e.g., /fr-fr/, /de-de/, etc.)
      const currentPath = window.location.pathname;
      const localeMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})\//);
      if (localeMatch) {
        return localeMatch[1];
      }
      
      // Fallback to clearpay variables if available
      const language = window.clearpay_js_language || 'en';
      const country = window.clearpay_js_country || 'GB';
      
      // Create proper locale string (language-country)
      return `${language}-${country}`;
    }

    getLocalizedBasePath() {
      // Get the localized base path for cart API calls
      // This ensures we hit the correct localized endpoints for EU markets
      
      // 1. Check current URL path for locale prefix (e.g., /fr-fr/, /de-de/, etc.)
      const currentPath = window.location.pathname;
      const localeMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})\//);
      
      if (localeMatch) {
        const locale = localeMatch[1];
        // Special case for UK market - use regular URLs
        if (locale === 'en-GB') {
          return '';
        }
        return `/${locale}`;
      }
      
      // 2. Try to get from shopifyLocalization
      if (window.shopifyLocalization?.locale) {
        const locale = window.shopifyLocalization.locale;
        // Special case for UK market - use regular URLs
        if (locale === 'en-GB') {
          return '';
        }
        return `/${locale}`;
      }
      
      // 3. Fallback to no locale prefix (UK/default market)
      return '';
    }

    async setupCheckoutUrl() {
      // Replicate exactly what the main cart page does - submit form to cart URL with checkout parameter
      this.checkoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Add a small delay to ensure all context is established
        setTimeout(() => {
          this.submitCartFormForCheckout();
        }, 50);
      });
    }

    async submitCartFormForCheckout() {

      
      // Wait a moment for any pending updates to complete
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Ensure we have the proper localized cart URL
      const cartUrl = await this.getLocalizedCartUrl();
      
      // Double-check currency context before submitting
      const currentCurrency = window.Shopify?.currency?.active || window.shopifyLocalization?.currency;
      
      // Verify we're using the localized URL (should contain locale prefix)
      const hasLocalePrefix = cartUrl.match(/^\/[a-z]{2}-[a-z]{2}\//);
      if (!hasLocalePrefix && (window.location.pathname.includes('-fr') || window.location.pathname.includes('-de'))) {
        console.warn('Warning: Cart URL may not be properly localized');
      }
      
      // Create a form that submits to the cart URL with checkout parameter
      // This exactly replicates what the main cart page does
      const form = document.createElement('form');
      form.method = 'post';
      form.action = cartUrl;
      
      // Add the checkout parameter (this is what triggers the checkout redirect)
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = '';
      form.appendChild(checkoutInput);
      
      // Add current currency context to help maintain it
      if (currentCurrency) {
        const currencyInput = document.createElement('input');
        currencyInput.type = 'hidden';
        currencyInput.name = 'currency';
        currencyInput.value = currentCurrency;
        form.appendChild(currencyInput);
      }
      
      // Add current locale context
      if (window.shopifyLocalization?.country) {
        const countryInput = document.createElement('input');
        countryInput.type = 'hidden';
        countryInput.name = 'country';
        countryInput.value = window.shopifyLocalization.country;
        form.appendChild(countryInput);
      }
      
      // Add CSRF token if available
      const csrfToken = document.querySelector('meta[name="csrf-token"]');
      if (csrfToken) {
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'authenticity_token';
        tokenInput.value = csrfToken.getAttribute('content');
        form.appendChild(tokenInput);
      }
      
      
      // Add form to DOM, submit it, then remove it
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }

    async handleRebuyCartChange() {
      try {
        const localizedBasePath = this.getLocalizedBasePath();
        const cartResp = await fetch(`${localizedBasePath}/cart.js`);
        if (!cartResp.ok) return;
        this.cart = await cartResp.json();
        // Best-effort get enriched cart data (totals, availability, etc.)
        try {
          this.cartData = await this.fetchCartData();
        } catch (e) {}
        // Re-render contents to reflect external cart changes
        this.renderCartContents(this.cart);
        // Refresh delivery upsell component
        if (this.rmDeliveryUpsell && typeof this.rmDeliveryUpsell.setupDisplay === 'function') {
          this.rmDeliveryUpsell.setupDisplay(this.cart.total_price);
        }
        // Update cart badge count
        const bubble = document.querySelector('.cart-count-bubble span');
        if (bubble) bubble.textContent = this.cart.item_count;
      } catch (e) {
        // Swallow errors to avoid breaking UX on external events
      }
    }

    handleRebuyPopupCloseClick(event) {
      try {
        const visiblePopup = document.querySelector('.rebuy-widget-container.widget-display-popup.is-visible');
        if (!visiblePopup) return;

        const clickedCloseBtn = event.target.closest && event.target.closest('.rebuy-modal-close');
        const clickedInsideContent = event.target.closest && event.target.closest('.rebuy-widget-content');

        // If clicking the explicit close button, do nothing (cart opens on add, not on close)
        if (clickedCloseBtn) return;

        // If clicking outside the content (on backdrop)
        if (!clickedInsideContent && visiblePopup.contains(event.target)) return;
      } catch (e) {
      }
    }

    setupRebuyPopupObserver() {
      try {
        this._rebuyPopupOpened = false;
        const isPopupVisible = () => {
          return document.querySelector('.rebuy-widget-container.widget-display-popup.is-visible');
        };

        const maybeOpenCart = () => {
          const visible = isPopupVisible();
          if (visible && !this._rebuyPopupOpened) {
            this._rebuyPopupOpened = true;
            // Do not open the cart on show; wait for modal close/backdrop click
          }
          if (!visible) {
            // Reset when popup hides so future openings trigger again
            this._rebuyPopupOpened = false;
          }
        };

        // Initial check in case it's already visible
        maybeOpenCart();

        const observer = new MutationObserver(() => {
          maybeOpenCart();
        });
        observer.observe(document.documentElement, {
          childList: true,
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
        this._rebuyPopupObserver = observer;
      } catch (e) {
      }
    }

    async getLocalizedCartUrl() {
      // Try multiple approaches to get the correct localized cart URL
      
      // 1. Check if Shopify routes has the localized cart URL
      if (window.Shopify?.routes?.cart_url) {
        return window.Shopify.routes.cart_url;
      }
      
      // 2. Build from current URL path
      const currentPath = window.location.pathname;
      const localeMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})\//);
      
      if (localeMatch) {
        const locale = localeMatch[1];
        // Special case for UK market - use regular cart URL instead of localized one
        if (locale === 'en-GB') {
          return '/cart';
        }
        const localizedCartUrl = `${localeMatch[0]}cart`;
        return localizedCartUrl;
      }
      
      // 3. Try to get from shopifyLocalization
      if (window.shopifyLocalization?.locale) {
        // Special case for UK market - use regular cart URL instead of localized one
        if (window.shopifyLocalization.locale === 'en-GB') {
          return '/cart';
        }
        const localizedCartUrl = `/${window.shopifyLocalization.locale}/cart`;
        return localizedCartUrl;
      }
      
      // 4. Fallback to regular cart URL
      return '/cart';
    }

    setupEventListeners() {
      this.mainContent.addEventListener('click', this.close.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));
      this.continueBtn.addEventListener('click', this.close.bind(this));
    }

    enableSpinner() {
      this.cartContent.classList.add('hidden');
      this.spinner.classList.remove('hidden');
    }

    disableSpinner() {
      this.spinner.classList.add('hidden');
      this.cartContent.classList.remove('hidden');
    }

    async addProduct(variantId, quantity) {
      // Set flag to prevent duplicate Algolia events from product-form.js
      window.realmedia.sideloadCartAdding = true;
      
      const body = {
        "items": [
          {
            "id": variantId,
            "quantity": quantity
          }
        ]
      };
      try {
        const localizedBasePath = this.getLocalizedBasePath();
        const request = await fetch(`${localizedBasePath}/cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });
        const cartData = await fetch(`${localizedBasePath}/cart.js`);
        this.cart = await cartData.json();
        this.cartData = await this.fetchCartData();
        this.renderCartContents(this.cart);
        
        // Add Algolia tracking for sideload cart add to cart
        try {
          if (typeof window.aa !== 'undefined') {
            // Get variant details for tracking
            const addedItem = this.cart.items.find(item => item.variant_id == variantId);
            if (addedItem) {
              // Get queryID from algolia_last_click if available
              const lastClickData = localStorage.getItem('algolia_last_click');
              let queryID = '';
              
              if (lastClickData) {
                try {
                  const clickInfo = JSON.parse(lastClickData);
                  queryID = clickInfo.queryID || '';
                } catch (e) {
                  console.warn('Error parsing algolia_last_click:', e);
                }
              }

              // Also check global queryID as fallback
              if (!queryID && window.realmedia && window.realmedia.lastRelatedProductsQueryID) {
                queryID = window.realmedia.lastRelatedProductsQueryID;
                }
              
              const eventData = {
                userToken: localStorage.getItem('aaUserTokenAnon'),
                eventName: 'added_to_cart',
                index: 'shopify_products',
                objectIDs: [variantId],
                objectData: [
                  {
                    price: parseFloat(addedItem.price / 100),
                    quantity: quantity
                  }
                ],
                value: parseFloat(addedItem.price / 100) * quantity,
                currency: window.Shopify.currency.active
              };
              
              // Add queryID if available
              if (queryID) {
                eventData.queryID = queryID;
              }
              
              if(localStorage.getItem('aaUserTokenAuth') != null) {
                eventData['authenticatedUserToken'] = localStorage.getItem('aaUserTokenAuth');
              }
              
              window.aa('addedToCartObjectIDs', eventData);
              
              // Store purchase data for checkout script compatibility
              const purchaseObject = {
                index: 'shopify_products',
                objectIDs: [variantId.toString()],
                eventName: 'Add To Cart',
                currency: window.Shopify.currency.active,
                timestamp: Date.now()
              };
              
              // Add queryID if available
              if (queryID) {
                purchaseObject.queryID = queryID;
              }
              
              // Store in purchase objects array
              const purchaseObjects = JSON.parse(localStorage.getItem('algolia_analytics_purchase_objects') || '[]');
              purchaseObjects.push(purchaseObject);
              
              // Keep only the last 20 purchase objects to prevent storage bloat
              const limitedPurchaseObjects = purchaseObjects.slice(-20);
              localStorage.setItem('algolia_analytics_purchase_objects', JSON.stringify(limitedPurchaseObjects));
              
              // Also store in sessionStorage for cross-domain access
              try {
                sessionStorage.setItem('algolia_analytics_purchase_objects', JSON.stringify(limitedPurchaseObjects));
              } catch (e) {
                console.warn('Failed to store sideload purchase objects in sessionStorage:', e);
              }
              
              // Clear recommendation click if it was used
              if (recommendationClick) {
                localStorage.removeItem('algolia_last_recommendation_click');
                console.log('🧹 Cleared used recommendation click data');
              }
            }
          }
        } catch (trackingError) {
          console.warn('Sideload cart Algolia tracking error:', trackingError);
        }
        
        // Removed Algolia recommendations trigger
        
        return true;
      } catch(err) {
        return false;
      } finally {
        // Clear flag to allow normal product form events
        window.realmedia.sideloadCartAdding = false;
      }
    }



    async changeQuantity(key, currQuantity, direction, event) {

      const qtyTextElem = event.target.closest('div').querySelector('.rm-sideload-cart-product-qty-count');
      const qtyButtons = event.target.closest('.rm-sideload-cart-product').querySelectorAll('.rm-sideload-cart-product-qty-btn');
      const quantity = direction === 'inc' ? currQuantity + 1 : currQuantity - 1;

      this.cartData = await this.fetchCartData();
      const itemData = this.cartData.items.length ? this.cartData.items.find(item => { return item.key == key }) : null;

      if(typeof itemData != 'undefined' && itemData != null) {
        if(currQuantity >= itemData.total_available && direction == 'inc') {
          alert(`All ${currQuantity} of this product are in your cart.`);
          return;
        }
      }
      
      qtyButtons.forEach(btn => btn.disabled = true);

      // do this first else the product doesn't exist in the basket
      let addableDataAll = { products: [], upsells: [] };
      try {
        if (localStorage.rmUpsellCartData) {
          addableDataAll = JSON.parse(localStorage.rmUpsellCartData);
        }
      } catch (error) {
        console.warn('Error parsing rmUpsellCartData:', error);
      }
      const addableData = addableDataAll.products.find(item => item.key == key);

      this.cart = await this.changeProduct(key, quantity);

      if(typeof addableData != 'undefined' && addableData.quantity != 0) {
        if(quantity == 0) {
          await this.changeAddable(key, 'remove');
        } else if(direction == 'dec' && addableData.quantity >= currQuantity) {
          await this.changeAddable(key, 'change', direction);
        }
      }
      
      this.cartData = await this.fetchCartData();
      
      this.renderCartContents(this.cart);

      // Update the delivery upsell element on the product page as well
      this.rmDeliveryUpsell.setupDisplay(this.cart.total_price);

      // Update cart bubble quantity
      document.querySelector('.cart-count-bubble span').textContent = this.cart.item_count;

      // When there are no more products available, the change endpoint will return the same quantity and won't return any errors.
      const updatedProduct = this.cart.items.find(item => item.key === key);

    }

    async changeAddable(productLineKey, type, direction) {

      let quantity;

      const productLine = this.cart.items.find(item => item.key == productLineKey);
      if (!productLine) {
        console.warn('No product found for productLineKey:', productLineKey);
        return;
      }
      
      // Find underlay items that have this product as their parent_rug_id
      const underlayItems = this.cart.items.filter(item => {
        return item.properties && item.properties.parent_rug_id == productLine.variant_id;
      });
      
      if (underlayItems.length === 0) {
        console.warn('No underlay items found for product:', productLine.variant_id);
        return;
      }
      
      // For now, handle the first underlay item
      const underlayItem = underlayItems[0];
      
      // Check if trying to increment beyond main product quantity
      if(type == 'change' && direction == 'inc') {
        const mainProductQuantity = productLine.quantity;
        const newUnderlayQuantity = underlayItem.quantity + 1;
        if(newUnderlayQuantity > mainProductQuantity) {
          console.warn('Cannot increment underlay beyond main product quantity');
          return false; // Prevent increment if it would exceed main product quantity
        }
      }

      // Calculate new quantity for the underlay
      if(type == 'remove') {
        quantity = 0; // Remove the underlay completely
      } else {
        quantity = direction == 'inc' ? underlayItem.quantity + 1 : underlayItem.quantity - 1;
        
        // Ensure quantity doesn't go below 0
        if (quantity < 0) {
          quantity = 0;
        }
      }

      // Update the underlay quantity using Shopify's cart change API
      this.cart = await this.changeProduct(underlayItem.key, quantity);
      this.cartData = await this.fetchCartData();

      // Return success result
      return {
        key: underlayItem.key,
        quantity: quantity,
        removed: quantity === 0
      };

    }

    async changeAddableQuantity(productLineKey, type, direction) {

      const updatedData = await this.changeAddable(productLineKey, type, direction);

      this.renderCartContents(this.cart);

      // Update the delivery upsell element on the product page as well
      this.rmDeliveryUpsell.setupDisplay(this.cart.total_price);

      // Update cart bubble quantity
      document.querySelector('.cart-count-bubble span').textContent = this.cart.item_count;

      if(!updatedData) {
        // Provide more specific error messages based on the operation
        if (type === 'change' && direction === 'inc') {
          alert('Cannot increase underlay quantity. This may be due to inventory limits or quantity constraints.');
        } else if (type === 'remove') {
          // Remove operation should always succeed, so this shouldn't happen
          console.warn('Remove operation returned false unexpectedly');
        } else {
          alert('Operation could not be completed. Please try again.');
        }
      } else if (updatedData.removed) {
        // Item was successfully removed
      }
      
    }

    async removeProduct(key, deleteBtn) {

      deleteBtn.classList.add('rm-opacity-50');

      // First, check if this product has an associated underlay and remove it
      try {
        if (localStorage.rmUpsellCartData) {
          const rmUpsellCartData = JSON.parse(localStorage.rmUpsellCartData);
          // Extract the product ID from the key (format: "id:key")
          const productId = key.split(':')[0];
          
          const productData = rmUpsellCartData.products.find(item => item.id == productId);
          
          if (productData && productData.upsellId) {
            // Fetch current cart data to ensure we have the latest state
            const currentCart = await this.fetchCart();
            const underlayItem = currentCart.items.find(item => item.id === productData.upsellId);
            
            if (underlayItem) {
              
              // Remove the underlay from cart first
              const updatedCart = await this.changeProduct(underlayItem.key, 0);
              
              // Update the upsell data
              const upsellIndex = rmUpsellCartData.upsells.findIndex(item => item.id === productData.upsellId);
              if (upsellIndex !== -1) {
                rmUpsellCartData.upsells.splice(upsellIndex, 1);
              }
              
              // Remove the product from upsell data
              const productIndex = rmUpsellCartData.products.findIndex(item => item.id == productId);
              if (productIndex !== -1) {
                rmUpsellCartData.products.splice(productIndex, 1);
              }
              
              // Update localStorage
              localStorage.setItem('rmUpsellCartData', JSON.stringify(rmUpsellCartData));
            }
          } 
        }
      } catch (error) {
        console.warn('Error removing associated underlay:', error);
      }

      // Now remove the main product
      this.cart = await this.changeProduct(key, 0);

      this.renderCartContents(this.cart);

      // Update the delivery upsell element on the product page as well
      this.rmDeliveryUpsell.setupDisplay(this.cart.total_price);

      // Update cart bubble quantity
      document.querySelector('.cart-count-bubble span').textContent = this.cart.item_count;
      
    }

    async open() {
      this.isOpen = true;
      this.scrollPosition = document.documentElement.scrollTop;

      // Trigger Rebuy to render before we apply body locks/transitions
      try {
        if (window.Rebuy && typeof window.Rebuy.refresh === 'function') {
          window.Rebuy.refresh();
        } else if (window.dispatchEvent) {
          window.dispatchEvent(new Event('rebuy:refresh'));
        }
      } catch (e) {}

      // Use requestAnimationFrame to prevent layout shifts
      requestAnimationFrame(() => {
        this.mainContent.classList.add('rm-bg-darkened');
        this.mainContentInner.classList.add('rm-clicks-disabled');
        
        // Removed: document.body.style.top = `-${this.scrollPosition}px`;
        document.body.classList.add('rm-scroll-prevented');
      });

      this.sideLoadCart.style.transition = 'transform .3s ease-in-out';
      this.sideLoadCart.classList.add('state--opened');

      this.enableSpinner();

      this.cart = await this.fetchCart();
      this.cartData = await this.fetchCartData();
      this.renderCartContents(this.cart);

      if(this.cart.items.length > 3) {
        this.sideLoadCart.classList.add('contracted-mobile');
      } else {
        this.sideLoadCart.classList.remove('contracted-mobile');
      }

      this.rmDeliveryUpsell.setupDisplay(this.cart.total_price);

      this.disableSpinner();

      rmINoBounceHelper.enable();

      // Removed Algolia recommendations trigger on open

    }

    // Removed loadCartRecommendations implementation

    close(e) {
      if (!this.isOpen) return;
      const ignoredElement = document.querySelector('[data-cart-trigger]');

      if (ignoredElement && ignoredElement.contains(e.target)) {
        return;
      }

      this.sideLoadCart.classList.remove('state--opened');

      // Use requestAnimationFrame to prevent layout shifts
      requestAnimationFrame(() => {
        this.mainContent.classList.remove('rm-bg-darkened');
        this.mainContentInner.classList.remove('rm-clicks-disabled');
        
        document.body.classList.remove('rm-scroll-prevented');
        
        // Restore scroll position and reset top
        window.scrollTo(0, this.scrollPosition);
        // Removed: document.body.style.top = '';
      });

      this.isOpen = false;

      rmINoBounceHelper.disable();

    }

    async fetchCart() {

      const localizedBasePath = this.getLocalizedBasePath();
      const response = await fetch(`${localizedBasePath}/cart.js`)
  
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
  
      const data = await response.json();

      return data;

    }

    async fetchCartData() {

      const localizedBasePath = this.getLocalizedBasePath();
      const response = await fetch(`${localizedBasePath}/cart?view=data-json`);
  
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
  
      const data = await response.json();

      return data;
      
    }

    async changeProduct(key, quantity) {

      const payload = {
        id: key,
        quantity: quantity
      };

      const config = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      };

      const localizedBasePath = this.getLocalizedBasePath();
      const response = await fetch(`${localizedBasePath}/cart/change.js`, config)
  
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
  
      const data = await response.json();

      return data;

    }

    async checkForUpsells(cart) {
      const cartItems = cart.items;
      cartItems.forEach(async (product, key) => {
        const metaData = await fetch(`/admin/products/${product.id}/metafields.json`);
        
      })
    }

    cleanupOrphanedUpsellData(cartItems, rmUpsellCartData) {
      // Get all variant IDs currently in the cart
      const cartVariantIds = cartItems.map(item => item.variant_id.toString());
      
      // Clean up products array - remove entries where the main product is no longer in cart
      const originalProductsLength = rmUpsellCartData.products.length;
      rmUpsellCartData.products = rmUpsellCartData.products.filter(product => {
        return cartVariantIds.includes(product.id.toString());
      });
      
      // Clean up upsells array - remove entries where the underlay is no longer in cart
      const originalUpsellsLength = rmUpsellCartData.upsells.length;
      rmUpsellCartData.upsells = rmUpsellCartData.upsells.filter(upsell => {
        return cartVariantIds.includes(upsell.id.toString());
      });
      
      // Update localStorage if we removed any orphaned entries
      if (rmUpsellCartData.products.length !== originalProductsLength || 
          rmUpsellCartData.upsells.length !== originalUpsellsLength) {
        try {
          localStorage.setItem('rmUpsellCartData', JSON.stringify(rmUpsellCartData));
        } catch (error) {
          console.warn('Error updating localStorage after cleanup:', error);
        }
      }
    }

    renderCartContents(cart) {

      const slideOutCart = this;
      const cartItems = cart.items;

      let rmUpsellCartData = null;
      try {
        if (localStorage.rmUpsellCartData) {
          rmUpsellCartData = JSON.parse(localStorage.rmUpsellCartData);
        }
      } catch (error) {
        console.warn('Error parsing rmUpsellCartData:', error);
        rmUpsellCartData = null;
      }

      // Clean up orphaned entries from localStorage when cart is updated
      if (rmUpsellCartData) {
        this.cleanupOrphanedUpsellData(cartItems, rmUpsellCartData);
      }

      // Handle delivery message visibility
      const deliveryMessage = document.querySelector('.rm-sideload-cart-delivery');
      if (deliveryMessage) {
        deliveryMessage.style.display = cartItems.length > 0 ? 'flex' : 'none';
      }

      // Removed upsells/recommendations visibility handling

      if (cartItems.length > 0) {
        this.cartContentBottom.classList.remove('hidden');
        this.productsContainer.innerHTML = '';
        // Show delivery message when cart has items
        const deliveryMessage = document.querySelector('.rm-sideload-cart-delivery');
        if (deliveryMessage) deliveryMessage.style.display = 'flex';
      } else {
        this.cartContentBottom.classList.add('hidden');
        this.productsContainer.innerHTML = `
          <div style="text-align: center; padding: 3rem 2rem;">
            <h2 style="font-size: var(--rm-font-21, 21px); font-weight: var(--rm-fontweight-semibold, 600); color: var(--rm-primary-dark, #222); margin: 0 0 2rem 0;">${window.cartStrings.rmEmptyCart}</h2>
            <a href="/collections/all-rugs" style="background: #478F4C; color: #fff; border: none; border-radius: 2rem; padding: 1rem 2rem; font-size: var(--rm-font-16, 16px); font-weight: var(--rm-fontweight-semibold, 600); text-decoration: none; display: inline-block; transition: background-color 0.2s ease;" onmouseover="this.style.background='#5BAE61'" onmouseout="this.style.background='#478F4C'">Continue Shopping</a>
          </div>
        `;
        // Hide delivery message when cart is empty
        const deliveryMessage = document.querySelector('.rm-sideload-cart-delivery');
        if (deliveryMessage) deliveryMessage.style.display = 'none';
        // Update progress bar even when cart is empty (pre-discount subtotal is 0)
        this.updateProgressBar(0);
        return;
      }

      cartItems.forEach((product, key) => {

        const productTemplate = document.getElementById('rm-sideload-cart-product-template');
        const templateClone = productTemplate.content.cloneNode(true);
        // Find underlay items that have this product as their parent_rug_id
        const underlayItems = cartItems.filter(item => {
          return item.properties && item.properties.parent_rug_id == product.variant_id;
        });
        
        // Check if this product itself is an underlay (has parent_rug_id property)
        const isAddableProduct = product.properties && product.properties.parent_rug_id;
        
        const productAddableElem = templateClone.querySelector('.rm-sideload-cart-product-addable');

        const productImgElem = templateClone.querySelector('.rm-sideload-cart-product-img');

        templateClone.querySelector('.rm-sideload-cart-product').classList.add('product-'+product.id);
        // Set currency data attribute with multiple fallback sources
        let currencyCode = 'gbp'; // default fallback
        // Prioritize more current/accurate sources over potentially stale cart data
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          currencyCode = window.Shopify.currency.active.toLowerCase();
        } else if (window.shopifyLocalization && window.shopifyLocalization.currency) {
          currencyCode = window.shopifyLocalization.currency.toLowerCase();
        } else if (cart.currency && cart.currency.iso_code) {
          currencyCode = cart.currency.iso_code.toLowerCase();
        } else if (typeof cart.currency === 'string') {
          currencyCode = cart.currency.toLowerCase();
        } else if (typeof window.clearpay_cart_currency !== 'undefined') {
          currencyCode = window.clearpay_cart_currency.toLowerCase();
        }
        templateClone.querySelector('.rm-sideload-cart-product').dataset.currency = currencyCode;
        
        // Only hide underlay items if they have a parent_rug_id property AND the parent product is still in the cart
        if(typeof isAddableProduct != 'undefined') {
          
          // Check if this underlay item has a parent_rug_id property
          const hasParentRug = product.properties && product.properties.parent_rug_id;
          
          if (hasParentRug) {
            // Check if the parent product is still in the cart
            const parentProductId = product.properties.parent_rug_id;
            const parentProductExists = cartItems.some(item => item.variant_id == parentProductId);
            
            if (parentProductExists) {
              // Hide underlay items that are linked to parent products that still exist
              // They will be shown as part of their parent product's display
              templateClone.querySelector('.rm-sideload-cart-product').classList.add('rm-hidden');
            } else {
              // Show orphaned underlay items as standard line items
              // The parent product has been removed, so this underlay should be displayed normally
              templateClone.querySelector('.rm-sideload-cart-product').classList.remove('rm-hidden');
            }
          }
        }

        productImgElem.src = this.buildSmallestImgUrl(product.image);

        if (!product.image) {
          productImgElem.classList.add('rm-invisible');
        }
        
        templateClone.querySelector('.rm-sideload-cart-product-title-link').textContent = product.product_title;
        if(product.variant_title != product.product_title) {
          templateClone.querySelector('.rm-sideload-cart-product-variant').textContent = product.variant_title;
        }
        templateClone.querySelector('.rm-sideload-cart-product-qty-count').textContent = product.quantity;
        
        // Display current price and original price (if different)
        const currentPrice = product.discounted_price * product.quantity;
        const originalPrice = product.price * product.quantity;
        const priceElement = templateClone.querySelector('.rm-sideload-cart-product-price');
        
        if (currentPrice < originalPrice) {
          // Show both current and original price
          priceElement.innerHTML = `${this.formatPrice(currentPrice)} <span class="rm-original-price" style="text-decoration: line-through; font-size: 0.75em; vertical-align: baseline; top: 0.15em;">${this.formatPrice(originalPrice)}</span>`;
        } else {
          // Show only current price
          priceElement.textContent = this.formatPrice(currentPrice);
        }

        if(underlayItems.length > 0) {
          let productAddableImg = productAddableElem.querySelector('.rm-addable-image');
          let productAddableMsg = productAddableElem.querySelector('.rm-addable-message');
          let productAddableMsgMissing = productAddableElem.querySelector('.rm-addable-message-missing');
          let productAddableDec = productAddableElem.querySelector('.rm-addable-dec');
          let productAddableInc = productAddableElem.querySelector('.rm-addable-inc');
          let productAddableQtyCount = productAddableElem.querySelector('.rm-addable-qty-count');
          let productAddableRemove = productAddableElem.querySelector('.rm-addable-remove');
          let productAddablePrice = productAddableElem.querySelector('.rm-addable-price');
          
          // For now, handle the first underlay item (could be extended for multiple underlay types)
          let addableItem = underlayItems[0];
          
          if(addableItem) {
            // Only show addable section if the underlay item actually exists in cart
            productAddableElem.classList.remove('rm-hidden');
            let addableLabel = addableItem.quantity != 1 ? 'underlays' : 'underlay';
            if(typeof addableItem != 'undefined') {
            if(addableItem.featured_image.url != null) productAddableImg.innerHTML = `<img src="${addableItem.featured_image.url}" alt="${addableItem.product_title}" />`;
              productAddableElem.dataset.addableKey = addableItem.key;
              productAddableElem.dataset.addableQty = addableItem.quantity;
            }
            productAddableElem.dataset.productQty = product.quantity;
            
            // Set currency data attribute for CSS-based currency symbol display
            let currencyCode = 'gbp'; // default fallback
            if (this.cart && this.cart.currency) {
              if (typeof this.cart.currency === 'object' && this.cart.currency.iso_code) {
                currencyCode = this.cart.currency.iso_code.toLowerCase();
              } else if (typeof this.cart.currency === 'string') {
                currencyCode = this.cart.currency.toLowerCase();
              }
            }
            productAddableElem.dataset.currency = currencyCode;
            
            // Always show current underlay quantity with controls
            productAddableMsg.textContent = `${addableItem.quantity}x ${addableLabel} ${addableItem.variant_title}`;
            // Update the quantity count display
            productAddableQtyCount.textContent = addableItem.quantity;
            if(product.quantity > addableItem.quantity) {
              const missingCount = product.quantity - addableItem.quantity;
              productAddableMsgMissing.textContent = `Add ${missingCount} more ${missingCount === 1 ? 'underlay' : 'underlays'} to match your rug quantity`;
              productAddableMsgMissing.style.color = '#C1445E'; // Red color for missing
            } else if(product.quantity === addableItem.quantity) {
              productAddableMsgMissing.textContent = `Perfect! You have the right number of underlays for your rugs`;
              productAddableMsgMissing.style.color = '#478F4C'; // Green color for success
            } else {
              productAddableMsgMissing.textContent = '';
            }
            
            // Show underlay quantity controls inline
            productAddableDec.style.display = 'inline-block';
            productAddableInc.style.display = 'inline-block';
            
            // Enable/disable controls based on current quantities
            if(addableItem.quantity <= 0) {
              productAddableDec.disabled = true;
              productAddableDec.style.opacity = '0.5';
              productAddableDec.style.cursor = 'not-allowed';
            } else {
              productAddableDec.disabled = false;
              productAddableDec.style.opacity = '1';
              productAddableDec.style.cursor = 'pointer';
            }
            
            // Disable increment button if upsell quantity has reached the main product quantity or inventory limit
            const maxAllowedQuantity = product.quantity; // Can't exceed main product quantity
            
            // Also check inventory limits if cartData is available
            let inventoryLimit = Infinity;
            if(this.cartData && this.cartData.items) {
              const addableItemData = this.cartData.items.find(item => item.key == addableItem.key);
              if(addableItemData && addableItemData.total_available) {
                inventoryLimit = addableItemData.total_available;
              }
            }
            
            const effectiveLimit = Math.min(maxAllowedQuantity, inventoryLimit);
            
            if(addableItem.quantity >= effectiveLimit) {
              productAddableInc.disabled = true;
              productAddableInc.style.opacity = '0.5';
              productAddableInc.style.cursor = 'not-allowed';
            } else {
              productAddableInc.disabled = false;
              productAddableInc.style.opacity = '1';
              productAddableInc.style.cursor = 'pointer';
            }
            
            if (productAddableDec) productAddableDec.addEventListener('click', this.changeAddableQuantity.bind(this, product.key, 'change', 'dec'));
            if (productAddableInc) productAddableInc.addEventListener('click', this.changeAddableQuantity.bind(this, product.key, 'change', 'inc'));
            if (productAddableRemove) productAddableRemove.addEventListener('click', this.changeAddableQuantity.bind(this, product.key, 'remove'));
  
            // Use the actual cart item price instead of cached price for correct currency
            const currentPrice = addableItem.discounted_price || addableItem.price;
            const originalPrice = addableItem.price;
            
            if (currentPrice < originalPrice) {
              // Show both current and original price
              productAddablePrice.innerHTML = `<span class="currency"></span><span class="price-value">${this.formatPriceWithoutCurrency(currentPrice)}</span>&nbsp;<span class="currency currency-strikethrough"></span><span class="rm-original-price" style="text-decoration: line-through; font-size: 0.75em; vertical-align: baseline; top: 0.15em;">${this.formatPriceWithoutCurrency(originalPrice)}</span>`;
            } else {
              // Show only current price
              productAddablePrice.innerHTML = `<span class="currency"></span><span class="price-value">${this.formatPriceWithoutCurrency(currentPrice)}</span>`;
            }
            
            // Also set currency on the price element itself to ensure CSS selector matches
            productAddablePrice.dataset.currency = currencyCode;
          }
          if(addableItem && addableItem.quantity == 0) productAddableElem.classList.add('rm-hidden');
        } 

        // Selected subscription plan. Coming from Appstle Subscriptions. Disable this for now as they can't sell subscriptions.
        // if (product.selling_plan_allocation) {
        //   templateClone.querySelector('.rm-sideload-cart-product-subs').textContent = product.selling_plan_allocation.selling_plan.name;
        // }

        const discountsPresent = product.discounts.length > 0;

        if (discountsPresent) {
          //templateClone.querySelector('.rm-sideload-cart-product-qty-dec').disabled = true;
          //templateClone.querySelector('.rm-sideload-cart-product-qty-inc').disabled = true;
        }

        // Append the first discount with icon and savings amount.
        const discountElement = templateClone.querySelector('.rm-sideload-cart-product-discounts');
        if (discountsPresent) {
          // Calculate savings amount for this line item
          // Use original_line_price if available (more accurate), otherwise calculate from unit prices
          const originalLinePrice = product.original_line_price !== undefined && product.original_line_price !== null 
            ? product.original_line_price 
            : (product.price * product.quantity);
          
          const finalLinePrice = product.final_line_price !== undefined && product.final_line_price !== null
            ? product.final_line_price
            : (product.discounted_price * product.quantity);
          
          const savingsAmount = originalLinePrice - finalLinePrice;
          
          // Format the savings amount with minus sign
          let savingsText = '';
          if (savingsAmount > 0) {
            const formattedSavings = this.formatPrice(savingsAmount);
            savingsText = ` (-${formattedSavings})`;
          }
          
          discountElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19"><g transform="translate(-1189.031 -720.035)"><g transform="translate(1189.531 720.535)"><path d="M180.06,42.276H175.9a4.454,4.454,0,0,0-2.783,1.153l-8.546,8.545a1.944,1.944,0,0,0,0,2.743l4.992,4.993a1.944,1.944,0,0,0,2.743,0l8.545-8.545A4.455,4.455,0,0,0,182,48.381V44.215a1.942,1.942,0,0,0-1.94-1.939Z" transform="translate(-164 -42.276)" fill="none" stroke="currentColor" stroke-width="1"></path></g><circle cx="1.668" cy="1.668" r="1.668" transform="translate(1201.865 722.864)" fill="currentColor"></circle></g></svg>
               <span>${product.discounts[0].title}${savingsText}</span>`;
        } else {
          discountElement.textContent = '';
        }

        // Render visible line item properties, excluding keys starting with underscore
        if (product.properties && Object.keys(product.properties).length > 0) {
          const propertiesElem = templateClone.querySelector('.rm-sideload-cart-product-properties');
          const visibleProps = Object.entries(product.properties)
            .filter(([key, value]) => key && key.charAt(0) !== '_' && value != null && String(value).trim() !== '');
          if (visibleProps.length > 0) {
            propertiesElem.textContent = visibleProps.map(([key, value]) => `${key}: ${value}`).join(', ');
          } else if (propertiesElem) {
            propertiesElem.textContent = '';
          }
        }

        const cloneUrls = templateClone.querySelectorAll('.rm-sideload-cart-product-link');
        cloneUrls.forEach(link => {
          link.setAttribute('href', product.url)
        });

        const quantityInc = templateClone.querySelector(".rm-sideload-cart-product-qty-inc");
        if (quantityInc) {
          quantityInc.addEventListener('click', this.changeQuantity.bind(this, product.key, product.quantity, 'inc'));
        }

        const quantityDec = templateClone.querySelector(".rm-sideload-cart-product-qty-dec");
        if (quantityDec) {
          quantityDec.addEventListener('click', this.changeQuantity.bind(this, product.key, product.quantity, 'dec'));
        }

        const deleteBtn = templateClone.querySelector(".rm-sideload-cart-product-delete");
        if (deleteBtn) {
          deleteBtn.addEventListener('click', this.removeProduct.bind(this, product.key, deleteBtn));
        }
        
        // Only append to DOM if the item is not hidden
        const isHidden = templateClone.querySelector('.rm-sideload-cart-product').classList.contains('rm-hidden');
        if (!isHidden) {
          this.productsContainer.appendChild(templateClone);
        } 

      });

      const cartItemsCount = document.querySelector('.rm-sideload-cart-items-count');
      if (cartItemsCount) cartItemsCount.textContent = cart.item_count;
      
      const cartSubtotalElement = document.querySelector('.rm-sideload-cart-subtotal-price');
      if (cartSubtotalElement) cartSubtotalElement.textContent = this.formatPrice(cart.items_subtotal_price);
      
      // Calculate pre-discount subtotal for progress bar
      // Sum all original_line_price values (price before discounts)
      let preDiscountSubtotal = 0;
      if (cartItems && cartItems.length > 0) {
        cartItems.forEach(item => {
          // Skip hidden underlay items (those with parent_rug_id property that are linked to parent products)
          const isHiddenUnderlay = item.properties && item.properties.parent_rug_id && 
                                   cartItems.some(parent => parent.variant_id == item.properties.parent_rug_id);
          
          if (!isHiddenUnderlay) {
            // Use original_line_price which is the price before discounts
            // If not available, fall back to price * quantity (original unit price * quantity)
            if (item.original_line_price !== undefined && item.original_line_price !== null) {
              preDiscountSubtotal += item.original_line_price;
            } else {
              // Fallback: calculate from original unit price and quantity
              const calculatedPrice = (item.price || 0) * (item.quantity || 0);
              preDiscountSubtotal += calculatedPrice;
            }
          }
        });
      }
      
      // Update progress bar with pre-discount subtotal
      this.updateProgressBar(preDiscountSubtotal);
      
    }

    displayFadeMsg(message) {
      let msgElem = document.getElementById("rm-sideload-cart-top-msg");
      msgElem.textContent = message;
      msgElem.style.display = 'block';
      msgElem.style.opacity = 1; 
      setTimeout(function() { 
        let timerId = setInterval(function() { 
          let opacity = msgElem.style.opacity; 
          if (opacity == 0) { 
            clearInterval(timerId); 
          } else {
            msgElem.style.opacity = opacity - 0.05;
          }
        }, 50);
      }, 5000);
      setTimeout(() => {
          msgElem.style.display = 'none';
      }, 7000)
    }

    updateProgressBar(cartSubtotal) {
      const progressBar = document.getElementById('rm-sideload-cart-progress-bar');
      if (!progressBar) return;

      const progressBarFill = progressBar.querySelector('.rm-sideload-cart-progress-bar-fill');
      if (!progressBarFill) return;

      // Get progress icons container
      const progressIcons = document.querySelector('.rm-sideload-cart-progress-icons');
      const progressMessageElement = document.getElementById('rm-sideload-cart-progress-message');

      // Ensure cartSubtotal is a valid number
      const subtotal = Number(cartSubtotal) || 0;
      
      // Hide progress bar when cart is empty
      if (subtotal === 0) {
        progressBar.style.display = 'none';
        if (progressIcons) progressIcons.style.display = 'none';
        if (progressMessageElement) progressMessageElement.style.display = 'none';
        return;
      } else {
        // Show progress bar when cart has items
        progressBar.style.display = 'block';
        if (progressIcons) progressIcons.style.display = 'flex';
        if (progressMessageElement) progressMessageElement.style.display = 'block';
      }

      // Get current currency first
      let currency = 'GBP'; // default fallback
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        currency = window.Shopify.currency.active.toUpperCase();
      } else if (window.shopifyLocalization && window.shopifyLocalization.currency) {
        currency = window.shopifyLocalization.currency.toUpperCase();
      } else if (this.cart && this.cart.currency) {
        if (typeof this.cart.currency === 'object' && this.cart.currency.iso_code) {
          currency = this.cart.currency.iso_code.toUpperCase();
        } else if (typeof this.cart.currency === 'string') {
          currency = this.cart.currency.toUpperCase();
        }
      } else if (typeof window.clearpay_cart_currency !== 'undefined') {
        currency = window.clearpay_cart_currency.toUpperCase();
      }

      // Get currency-specific threshold from window.rmProgressBarThresholds
      // Thresholds are stored in pence/cents (major currency units * 100)
      // If threshold is 0, it means the bar should be considered completed
      let threshold = 17500; // Default fallback (175 GBP in pence)
      let thresholdFound = false;
      
      if (window.rmProgressBarThresholds && typeof window.rmProgressBarThresholds === 'object') {

        // Try to get threshold for detected currency first (including 0)
        let currencyKey = currency.toLowerCase();
        if (window.rmProgressBarThresholds[currencyKey] !== undefined && window.rmProgressBarThresholds[currencyKey] !== null) {
          threshold = Number(window.rmProgressBarThresholds[currencyKey]);
          thresholdFound = true;
        } else {
          // Fallback: try GBP, EUR, USD in order
          if (window.rmProgressBarThresholds.gbp !== undefined && window.rmProgressBarThresholds.gbp !== null) {
            threshold = Number(window.rmProgressBarThresholds.gbp);
            thresholdFound = true;
          } else if (window.rmProgressBarThresholds.eur !== undefined && window.rmProgressBarThresholds.eur !== null) {
            threshold = Number(window.rmProgressBarThresholds.eur);
            thresholdFound = true;
          } else if (window.rmProgressBarThresholds.usd !== undefined && window.rmProgressBarThresholds.usd !== null) {
            threshold = Number(window.rmProgressBarThresholds.usd);
            thresholdFound = true;
          }
        }
      } else {
        console.warn('window.rmProgressBarThresholds not found, using default threshold');
      }
      
      console.log('Final threshold used:', threshold, 'pence/cents for currency:', currency);
      
      // Handle threshold of 0 - treat as completed
      const isThresholdZero = threshold === 0;
      
      // Calculate progress percentage
      // If threshold is 0, progress is 100% (completed)
      // Otherwise calculate based on subtotal vs threshold
      let progress;
      if (isThresholdZero) {
        progress = 100;
      } else {
        progress = Math.min((subtotal / threshold) * 100, 100);
      }
      
      // Update the progress bar fill width
      progressBarFill.style.width = `${progress}%`;
      
      // Update discount icon state when threshold is reached or threshold is 0
      const discountIcon = document.getElementById('rm-sideload-cart-progress-icon-discount');
      if (discountIcon) {
        if (isThresholdZero || subtotal >= threshold) {
          discountIcon.classList.add('active');
        } else {
          discountIcon.classList.remove('active');
        }
      }
      
      // Update progress message with remaining amount
      const progressMessage = document.getElementById('rm-sideload-cart-progress-message');
      if (progressMessage) {
        // Hide message if threshold is 0 or if threshold is reached
        if (isThresholdZero || subtotal >= threshold) {
          // Threshold reached or disabled (0) - hide message
          progressMessage.textContent = '';
          progressMessage.style.display = 'none';
        } else {
          // Show message
          progressMessage.style.display = 'block';
          
          if (window.rmProgressBarMessage) {
            // Calculate remaining amount
            const remaining = threshold - subtotal;
            const formattedAmount = this.formatPrice(remaining);
            
            // Replace {{amount}} placeholder with formatted amount
            const message = window.rmProgressBarMessage.replace('{{amount}}', formattedAmount);
            progressMessage.textContent = message;
          } else {
            // Fallback message if setting not available
            const remaining = threshold - subtotal;
            const formattedAmount = this.formatPrice(remaining);
            progressMessage.textContent = `You are ${formattedAmount} away from 20% off your entire order!`;
          }
        }
      }
    }

    formatPriceWithoutCurrency(priceInPence) {
      // Format price as a plain number without currency symbol
      // This is used for underlay prices where the currency symbol is added via CSS
      
      // Get current locale, refresh it to ensure we have the latest
      let locale = this.getLocaleFromGlobalVars();
      
      // Extract country code from locale (part after hyphen) for proper number formatting
      // Shopify uses formats like en-fr, en-es, etc. where country determines number format
      let formattingLocale = locale;
      if (locale && locale.includes('-')) {
        const countryCode = locale.split('-')[1].toUpperCase();
        
        // Map country codes to proper locales for number formatting
        const countryLocaleMap = {
          'FR': 'fr-FR',  // France - comma decimal
          'DE': 'de-DE',  // Germany - comma decimal  
          'ES': 'es-ES',  // Spain - comma decimal
          'IT': 'it-IT',  // Italy - comma decimal
          'NL': 'nl-NL',  // Netherlands - comma decimal
          'PT': 'pt-PT',  // Portugal - comma decimal
          'PL': 'pl-PL',  // Poland - comma decimal
          'SE': 'sv-SE',  // Sweden - comma decimal
          'DK': 'da-DK',  // Denmark - comma decimal
          'NO': 'nb-NO',  // Norway - comma decimal
          'FI': 'fi-FI',  // Finland - comma decimal
          'AT': 'de-AT',  // Austria - comma decimal
          'BE': 'fr-BE',  // Belgium - comma decimal
          'GB': 'en-GB',  // UK - period decimal
          'US': 'en-US',  // US - period decimal
          'CA': 'en-CA',  // Canada - period decimal
          'AU': 'en-AU'   // Australia - period decimal
        };
        
        if (countryLocaleMap[countryCode]) {
          formattingLocale = countryLocaleMap[countryCode];
        }
      }
      
      try {
        const formatted = new Intl.NumberFormat(formattingLocale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(priceInPence / 100);
        
        return formatted;
      } catch (error) {
        console.warn('Error formatting price without currency with locale', formattingLocale, ':', error);
        
        // Fallback: try with just the language part of the formatting locale
        try {
          const languageOnly = formattingLocale.split('-')[0];
          return new Intl.NumberFormat(languageOnly, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(priceInPence / 100);
        } catch (fallbackError) {
          console.warn('Fallback formatting also failed:', fallbackError);
          
          // Ultimate fallback: use 'en-GB' locale for proper UK formatting
          return new Intl.NumberFormat('en-GB', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(priceInPence / 100);
        }
      }
    }

    formatPrice(priceInPence) {
      // Get currency with multiple fallback sources
      let currency = 'GBP'; // default fallback
      // Prioritize more current/accurate sources over potentially stale cart data
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        currency = window.Shopify.currency.active;
      } else if (window.shopifyLocalization && window.shopifyLocalization.currency) {
        currency = window.shopifyLocalization.currency;
      } else if (this.cart && this.cart.currency) {
        // Handle case where currency is an object with iso_code
        if (typeof this.cart.currency === 'object' && this.cart.currency.iso_code) {
          currency = this.cart.currency.iso_code;
        } else if (typeof this.cart.currency === 'string') {
          // Handle case where currency is a string directly
          currency = this.cart.currency;
        }
      } else if (typeof window.clearpay_cart_currency !== 'undefined') {
        currency = window.clearpay_cart_currency;
      }
      
      // Get current locale, refresh it to ensure we have the latest
      let locale = this.getLocaleFromGlobalVars();
      
      // Extract country code from locale (part after hyphen) for proper number formatting
      // Shopify uses formats like en-fr, en-es, etc. where country determines number format
      let formattingLocale = locale;
      if (locale && locale.includes('-')) {
        const countryCode = locale.split('-')[1].toUpperCase();
        
        // Map country codes to proper locales for number formatting
        const countryLocaleMap = {
          'FR': 'fr-FR',  // France - comma decimal
          'DE': 'de-DE',  // Germany - comma decimal  
          'ES': 'es-ES',  // Spain - comma decimal
          'IT': 'it-IT',  // Italy - comma decimal
          'NL': 'nl-NL',  // Netherlands - comma decimal
          'PT': 'pt-PT',  // Portugal - comma decimal
          'PL': 'pl-PL',  // Poland - comma decimal
          'SE': 'sv-SE',  // Sweden - comma decimal
          'DK': 'da-DK',  // Denmark - comma decimal
          'NO': 'nb-NO',  // Norway - comma decimal
          'FI': 'fi-FI',  // Finland - comma decimal
          'AT': 'de-AT',  // Austria - comma decimal
          'BE': 'fr-BE',  // Belgium - comma decimal
          'GB': 'en-GB',  // UK - period decimal
          'US': 'en-US',  // US - period decimal
          'CA': 'en-CA',  // Canada - period decimal
          'AU': 'en-AU'   // Australia - period decimal
        };
        
        if (countryLocaleMap[countryCode]) {
          formattingLocale = countryLocaleMap[countryCode];
        }
      }
      
      // Currency symbol mapping for fallback
      const currencySymbolMap = {
        'GBP': '£',
        'EUR': '€',
        'USD': '$',
        'CAD': '$',
        'AUD': '$',
        'JPY': '¥',
        'CHF': 'CHF',
        'SEK': 'kr',
        'DKK': 'kr',
        'NOK': 'kr',
        'PLN': 'zł',
        'CZK': 'Kč'
      };
      
      try {
        // Format with currency, but ensure euro symbol is always in front to match site convention
        const formatted = new Intl.NumberFormat(formattingLocale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'symbol'
        }).format(priceInPence / 100);
        
        // Check if formatted string contains currency code instead of symbol (fallback case)
        const currencyUpper = currency.toUpperCase();
        if (formatted.includes(currencyUpper) && currencySymbolMap[currencyUpper]) {
          // Replace currency code with symbol
          const numberPart = formatted.replace(currencyUpper, '').trim();
          return `${currencySymbolMap[currencyUpper]}${numberPart}`;
        }
        
        // Ensure currency symbols are always in front to match site convention
        // Some locales put currency symbols after the number, but site uses prefix style
        if (currency === 'EUR' && formatted.endsWith('€')) {
          const numberPart = formatted.slice(0, -1).trim();
          return `€${numberPart}`;
        }
        
        return formatted;
      } catch (error) {
        console.warn('Error formatting price with locale', formattingLocale, 'and currency', currency, ':', error);
        
        // Fallback: try with just the language part of the formatting locale
        try {
          const languageOnly = formattingLocale.split('-')[0];
          const formatted = new Intl.NumberFormat(languageOnly, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'symbol'
          }).format(priceInPence / 100);
          
          // Check if formatted string contains currency code instead of symbol (fallback case)
          const currencyUpperFallback = currency.toUpperCase();
          if (formatted.includes(currencyUpperFallback) && currencySymbolMap[currencyUpperFallback]) {
            // Replace currency code with symbol
            const numberPart = formatted.replace(currencyUpperFallback, '').trim();
            return `${currencySymbolMap[currencyUpperFallback]}${numberPart}`;
          }
          
          // Ensure currency symbols are always in front to match site convention
          if (currency === 'EUR' && formatted.endsWith('€')) {
            const numberPart = formatted.slice(0, -1).trim();
            return `€${numberPart}`;
          }
          
          return formatted;
        } catch (fallbackError) {
          console.warn('Fallback formatting also failed:', fallbackError);
          
          // Ultimate fallback: use 'en-GB' locale for proper UK formatting
          const formatted = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'symbol'
          }).format(priceInPence / 100);
          
          // Check if formatted string contains currency code instead of symbol (fallback case)
          const currencyUpper = currency.toUpperCase();
          if (formatted.includes(currencyUpper) && currencySymbolMap[currencyUpper]) {
            // Replace currency code with symbol
            const numberPart = formatted.replace(currencyUpper, '').trim();
            return `${currencySymbolMap[currencyUpper]}${numberPart}`;
          }
          
          // Ensure currency symbols are always in front to match site convention
          if (currency === 'EUR' && formatted.endsWith('€')) {
            const numberPart = formatted.slice(0, -1).trim();
            return `€${numberPart}`;
          }
          
          return formatted;
        }
      }
    }

    buildSmallestImgUrl(origUrl) {
      // Append _165x to end of file name to load the smallest images
      if (origUrl === null) { return };
      const desiredSize = "_165x";
      const position = origUrl.indexOf('.png') > -1 ? origUrl.indexOf('.png') : origUrl.indexOf('.jpg');
      return [origUrl.slice(0, position), desiredSize, origUrl.slice(position)].join('');
    }

    checkUpsells() {
      const upsellNotice = this.rmProductUpsell;
      if(upsellNotice == null) return;
      const localizedBasePath = this.getLocalizedBasePath();
      fetch(`${localizedBasePath}/cart?view=upsells.json`)
        .then(response => response.json())
        .then(state => {
          if(state.upsellsMissing) {
            upsellNotice.style.display = "block";
            upsellNotice.querySelector('.cart__upsell-paragraph').textContent = `${state.upsellsMissingCount} item(s) don't have underlays`;
          } else {
            upsellNotice.style.display = "none";
          }
        })
    }

  });
}